import { buildQueryString } from './../../../helpers/src/QueryHelper';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { axiosBaseQuery } from './baseQuery';

const REGION_URL = '/api/regions';

export const regionAPI = createApi({
  reducerPath: 'region.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['regionInfo'],
  endpoints: (builder) => ({
    getListRegionByCountry: builder.mutation({
      query: ({ country = '' }) => {
        const queryString = buildQueryString({
          country,
        });
        return { url: `${REGION_URL}?${queryString}` };
      },
    }),
  }),
});

export const { useGetListRegionByCountryMutation } = regionAPI;
